/* Activates select inputs with Tom Select
 *
 * Use like so:
 *
 * <select data-controller='forms--select'>...
 *
 */
import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class extends Controller {
  static values = {
    allowEmptyOption: Boolean,
    withDropdownInput: Boolean,
    withRemoveButton: Boolean
  }

  connect () {
    this.initializeTomSelect()
  }

  disconnect () {
    this.destroyTomSelect()
  }

  initializeTomSelect () {
    // Configure tom-select plugin options
    const pluginOptions = {
      dropdown_input: this.withDropdownInputValue
    }
    const pluginSelection = Object.entries(pluginOptions)
      .filter(([key, value]) => value === true)
      .map(([key]) => key)

    let config = {
      maxOptions: null,
      searchConjunction: 'or',
      allowEmptyOption: this.allowEmptyOptionValue,
      plugins: pluginSelection,
      onChange: function () {
        // shows placeholder if null value is selected
        !this.getValue() && this.clear(true)
      }
    }

    if (this.withRemoveButtonValue) {
      config = {
        ...config,
        plugins: {
          remove_button: { title: 'remove' }
        }
      }
    }

    this.selectInput = new TomSelect(this.element, config)
  }

  destroyTomSelect () {
    if (this.element.tomselect) {
      this.element.tomselect.destroy()
    }
  }
}
